import { RootState } from 'store/reducers'

export const selectInvoicesManualXML = (state: RootState) =>
  state.invoices2.newCFDI.manualXMLUpload
